import React from "react";

/**
 * AI Homework Buddy official logo (uploaded PNG - horizontal wordmark + Lumi).
 * Do NOT redesign, redraw, alter, replace, distort, recolor, or generate variants.
 */
export function BuddyLogo({ size = 44, showWordmark = true, className = "" }) {
  // The image already contains "AI Homework Buddy" wordmark, so `showWordmark`
  // only controls whether we render the small tagline underneath.
  const height = size;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="app-logo">
      <img
        src="/brand/logo.png"
        alt="AI Homework Buddy"
        style={{ height, width: "auto" }}
        className="object-contain select-none pointer-events-none"
        draggable={false}
      />
      {showWordmark && (
        <div className="hidden xl:block leading-tight -ml-1">
          <div className="text-[10px] uppercase tracking-[0.18em] text-blue-700 font-bold">
            Learn Smarter. Do Better.
          </div>
        </div>
      )}
    </div>
  );
}

/**
 * Lumi mascot - official brand character (uploaded).
 * Do NOT redesign, redraw, alter, replace, distort, recolor, or generate variants.
 */
export function LumiMascot({ size = 120, mood = "happy", className = "" }) {
  return (
    <img
      src="/brand/lumi.png"
      alt="Lumi, your AI tutor mascot"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`inline-block object-contain select-none pointer-events-none ${className}`}
      draggable={false}
      data-testid="lumi-mascot"
      data-mood={mood}
    />
  );
}
